'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BidHistoryRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BidHistoryRemote = exports.BidHistoryRemote = {
    fetchBidHistory: function fetchBidHistory(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemId = _ref.itemId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/bid-history/' + itemId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/bidHistory.js
// module id = uC6t
// module chunks = 60